export default "__VITE_ASSET__Br21Y26A__"